<p-tabMenu [model]="items" [activeItem]="activeItem"  (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>